/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'calendar': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M1.605 5.813h16.593" _stroke="#008AFF" stroke-width="2"/><path pid="1" d="M18.4 3.465c0-.972-.787-1.759-1.758-1.759H3.158c-.971 0-1.759.787-1.759 1.759v13.484c0 .971.788 1.758 1.759 1.758h13.484c.971 0 1.759-.787 1.759-1.758V3.465z" _stroke="#234357" stroke-width="2" stroke-linecap="round"/><path pid="2" _stroke="#234357" d="M9.5 14.5h1v1h-1zM13.5 14.5h1v1h-1zM5.5 14.5h1v1h-1zM13.5 10.5h1v1h-1zM9.5 10.5h1v1h-1zM5.5 10.5h1v1h-1z"/></g>'
  }
})
